"use client";
import Link from "next/link";
import React, { useState, useEffect } from "react";
import { fetchWrapper } from "@/helpers";
import { ShelvingUnit } from "lucide-react";

export default function Nav() {
     const sentenceCase = (str) => {
          if (!str) return "";
          return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
     };
	const [isHovered, setIsHovered] = useState(false);
     const [categories, setCategories] = useState([]);
     const [activeCategory, setActiveCategory] = useState(null);
     const [depoziteHovered, setDepoziteHovered] = useState(false);
     const [depots, setDepots] = useState([]);

     useEffect(() => {
          async function fetchCategories() {
               const response = await fetchWrapper.get(`/api/categories?includeChildren=true`);
               setCategories(response.categories || []);
          };
          fetchCategories();
     }, []);

     useEffect(() => {
          fetch("/api/depozite")
               .then((r) => r.json())
               .then((d) => setDepots(d.depots || []))
               .catch(() => {});
     }, []); 

	return (
		<>
                    <style jsx>{`
               .pulse-link {
                    animation: pulseLink 1.5s infinite ease-in-out;
               }

               @keyframes pulseLink {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.05); }
                    100% { transform: scale(1); }
               }
               `}</style>
		
			<li
                      style={{ paddingLeft: 75, position: "relative" }}
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={(e) => {
                        // daca mouse-ul a intrat in dropdown (sau in alt copil), nu inchide
                        if (e.relatedTarget instanceof Node && e.currentTarget.contains(e.relatedTarget)) return;
                        setIsHovered(false);
                      }}
                    >
                      <Link
                        href="/"
                        className="item-link dropdown-toggle categoriesLink"
                        id="categoriiDropdown"
                      >
                        <i className="icon icon-list" style={{ fontSize: 18 }} />{" "}
                        Produse
                      </Link>
                    
                      <ul
                        className={`dropdown-menu ${isHovered ? "show" : ""}`}
                        aria-labelledby="categoriiDropdown"
                        style={{ 
                          marginTop: 0, 
                          padding: 0, 
                          overflow: "hidden", 
                          minWidth: activeCategory?.children?.length > 0 ? "1000px" : "320px",
                          maxHeight: "480px", // More compact height
                          border: "1px solid #ddd",
                          boxShadow: "0 10px 40px rgba(0,0,0,0.15)"
                        }}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => {
                          setIsHovered(false);
                          setActiveCategory(null);
                        }}
                      >
                        <div className="d-flex" style={{ height: "480px" }}>
                          <ul
                            className="list-unstyled mb-0 custom-scrollbar"
                            style={{ 
                              flex: "0 0 320px", // WIDER left column
                              borderRight: "1px solid #eee",
                              overflowY: "auto",
                              overflowX: "hidden", // NO horizontal scroll
                              background: "#fcfcfc"
                            }}
                          >
                            {categories.map((category, index) => (
                              <li 
                                key={index}
                                onMouseEnter={() => setActiveCategory(category)}
                              >
                                <Link 
                                  href={`/${category.slug}`} 
                                  className={`dropdown-item d-flex align-items-center ${activeCategory?.id === category.id ? "active-cat" : ""}`}
                                  style={{ 
                                    padding: "10px 20px", // more compact padding
                                    fontSize: "14px",
                                    borderLeft: activeCategory?.id === category.id ? "3px solid #007bff" : "3px solid transparent",
                                    justifyContent: "flex-start",
                                    textAlign: "left",
                                    whiteSpace: "nowrap"
                                  }}
                                >
                                  <span style={{ flexGrow: 1, textAlign: "left" }}>
                                    {sentenceCase(category.name)}
                                  </span>
                                  {category.children?.length > 0 && <span style={{ opacity: 0.5, marginLeft: "auto", fontSize: "18px" }}>›</span>}
                                </Link>
                              </li>
                            ))}
                          </ul>

                          <div 
                            className="subcategory-panel"
                            style={{ 
                              flex: 1, 
                              background: "#fff", 
                              width: "700px", 
                              display: activeCategory?.children?.length > 0 ? "block" : "none",
                              position: "relative",
                              overflow: "hidden"
                            }}
                          >
                            {/* Background Image (Fixed relative to panel) */}
                            {activeCategory?.image && (
                              <div 
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  right: 0,
                                  bottom: 0,
                                  left: 0,
                                  backgroundImage: `linear-gradient(to right, #ffffff 10%, rgba(255,255,255,0.7) 40%, transparent 100%), url("${activeCategory.image}")`,
                                  backgroundSize: "cover",
                                  backgroundPosition: "right center",
                                  backgroundRepeat: "no-repeat",
                                  opacity: 0.5,
                                  pointerEvents: "none",
                                  zIndex: 0
                                }}
                              />
                            )}

                            {/* Scrolling Content Wrapper */}
                            <div 
                              className="custom-scrollbar"
                              style={{ 
                                position: "relative", 
                                zIndex: 1, 
                                height: "480px", 
                                overflowY: "auto", 
                                padding: "30px" 
                              }}
                            >
                              {activeCategory && (
                                <div style={{ position: "relative", marginBottom: "20px" }}>
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h5 className="mb-0" style={{ fontWeight: 800, letterSpacing: "-0.5px", color: "#111", textTransform: "none" }}>
                                      {sentenceCase(activeCategory.name)}
                                    </h5>
                                    <Link href={`/${activeCategory.slug}`} style={{ fontSize: "12px", color: "#007bff", fontWeight: 600 }}>
                                      Vezi toate produsele ›
                                    </Link>
                                  </div>
                                  <hr style={{ opacity: 0.1, margin: "0" }} />
                                </div>
                              )}

                              <div className="row">
                                {activeCategory?.children?.map((sub, subIdx) => (
                                  <div key={subIdx} className="col-12 mb-4">
                                    <Link 
                                      href={`/${activeCategory.slug}/${sub.slug}`}
                                      className="subcategory-link fw-bold text-dark d-block mb-1"
                                      style={{ textDecoration: "none", fontSize: "14px", color: "#333" }}
                                    >
                                      {sentenceCase(sub.name)}
                                    </Link>
                                    <div className="d-flex flex-wrap" style={{ gap: "8px 15px" }}>
                                      {(sub.subChildren || []).map((third, thirdIdx) => (
                                        <Link
                                          key={thirdIdx}
                                          href={`/${activeCategory.slug}/${sub.slug}/${third.slug}`}
                                          className="third-category-link"
                                          style={{ 
                                            fontSize: "12px", 
                                            textDecoration: "none", 
                                            color: "#666",
                                            padding: "2px 0",
                                            whiteSpace: "nowrap" // keeps words together but allows container to wrap
                                          }}
                                        >
                                          {sentenceCase(third.name)}
                                        </Link>
                                      ))}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </ul>
                    </li>

                    {/* Depozite dropdown */}
                    <li
                      style={{ paddingLeft: 24, position: "relative" }}
                      onMouseEnter={() => setDepoziteHovered(true)}
                      onMouseLeave={() => setDepoziteHovered(false)}
                    >
                      <Link
                        href="/depozite/a"
                        className="item-link dropdown-toggle"
                        id="depoziteDropdown"
                        onClick={(e) => depots.length && e.preventDefault()}
                      >
                        <ShelvingUnit size={18} style={{ verticalAlign: "middle", marginRight: 4 }} />
                        Depozite
                      </Link>
                      {depots.length > 0 && (
                        <ul
                          className={`dropdown-menu ${depoziteHovered ? "show" : ""}`}
                          aria-labelledby="depoziteDropdown"
                          style={{
                            marginTop: 0,
                            padding: "8px 0",
                            minWidth: "200px",
                            border: "1px solid #ddd",
                            boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
                          }}
                          onMouseEnter={() => setDepoziteHovered(true)}
                          onMouseLeave={() => setDepoziteHovered(false)}
                        >
                          {depots.map((depot, i) => (
                            <li key={i}>
                              <Link
                                href={`/depozite/${depot.slug}`}
                                className="dropdown-item"
                                style={{ padding: "10px 20px", fontSize: "14px" }}
                              >
                                {depot.label}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>

                     <style jsx>{`
               .pulse-link {
                    animation: pulseLink 1.5s infinite ease-in-out;
               }

               @keyframes pulseLink {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.05); }
                    100% { transform: scale(1); }
               }

               .dropdown-item:hover, .active-cat {
                    background-color: #f5f5f5 !important;
                    color: #000 !important;
                    text-align: left !important;
                    justify-content: flex-start !important;
               }

               .subcategory-link, .third-category-link {
                    text-align: left !important;
               }

                .dropdown-menu {
                    text-align: left;
               }

               .custom-scrollbar::-webkit-scrollbar {
                    width: 6px;
               }
               .custom-scrollbar::-webkit-scrollbar-track {
                    background: #f1f1f1;
               }
               .custom-scrollbar::-webkit-scrollbar-thumb {
                    background: #ccc;
                    border-radius: 10px;
               }
               .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                    background: #aaa;
               }
               `}</style>	<li className="menu-item">
				<Link href="/" className="item-link">
					<i
						className="icon icon-home"
						style={{ fontSize: 18 }}
					/>{" "}
					Acasă
				</Link>
			</li>

			<li className="menu-item">
				<Link href="/toate-produsele" className="item-link">
					<i
						className="icon icon-bag"
						style={{ fontSize: 18 }}
					/>{" "}
					Magazin
				</Link>
			</li>
			<li className="menu-item">
				<Link href="/craciun" className="item-link" style={{ color: "#c0392b" }}>
					🎄 Crăciun
				</Link>
			</li>
			<li className="menu-item">
				<Link href="/contact" className="item-link">
					<i
						className="icon icon-mail"
						style={{ fontSize: 16 }}
					></i>{" "}
					Contact
				</Link>
			</li>
		</>
	);
}
